module.exports = require('./lib/linkify');



//////////////////
// WEBPACK FOOTER
// ./~/linkifyjs/index.js
// module id = 212
// module chunks = 1